"use strict";
/**
 * @module Services.ReplaceLicence
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Data type for a UPDATE_LICENCE response.
 */
var ReplaceLicenceResponse = /** @class */ (function () {
    /**
     * Create a new ReplaceLicence instance
     *
     * @param type  the byte ID of the response
     * @param resString  the string response of the licence update
     */
    function ReplaceLicenceResponse(type, resString) {
        this.type = type;
        this.resString = resString;
    }
    return ReplaceLicenceResponse;
}());
exports.ReplaceLicenceResponse = ReplaceLicenceResponse;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/replace-licence/replace-licence-response.js
// module id = 1359
// module chunks = 1